<template>
  <div class="schoolManage">
    <div class="breadcrumb" style="font-size: 14px;">
      校区管理
      <el-button type="primary" class="right_f" @click="getallschool">新增校区</el-button>
    </div>
    <!--弹出框带表单,增加校区-->
    <el-dialog title="新增校区" v-model="dialogFormVisible" :modal-append-to-body="false">
      <el-form :model="form" ref="form" id="addForm" label-position="left">
        <el-form-item label="注意事项:" :label-width="formLabelWidth">
          <br />
          <p style="color: red">
            1,没有匹配的学校请选择其它，请勿留空，没有选择选项之前请勿点击确定按钮
          </p>
          <p style="color: red">2,选择其它后请填写学校名称后再提交</p>
        </el-form-item>

        <el-form-item label="高校名称" :label-width="formLabelWidth" :modal-append-to-body="false">
        </el-form-item>
        <el-select v-model="value2" filterable clearable placeholder="请选择学校" @change="isaddnewschool">
          <el-option v-for="item in options1" :label="item.name" :key="item.rootUnid + item.name + item.firstLetter"
            :value="item.rootUnid + ',' + item.firstLetter + ',' + item.name">
          </el-option>
        </el-select>
        <el-form-item label="学校类型" label-width="80px" v-show="inputnewschoolvisble">
          <el-radio-group v-model="form.schoolType" @change="changeSchoolType">
            <el-radio :label="1">大学</el-radio>
            <el-radio :label="4">高中</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="高校名称" :label-width="formLabelWidth" v-show="inputnewschoolvisble">
          <el-input v-model="inputnewschool" placeholder="请输入高校名称"></el-input>
          <!--这里最开始是不可见的-->
        </el-form-item>

        <el-form-item label="校区名称" :label-width="formLabelWidth">
          <el-input placeholder="请输入校区名称" v-model="form.namecampus" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="省份" :label-width="formLabelWidth" required>
          <el-select v-model="form.province" placeholder="请选择省份" clearable filterable style="width: 100%"
            @change="form.city = ''">
            <el-option v-for="item in provinceList" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="市" :label-width="formLabelWidth" required>
          <el-select v-model="form.city" placeholder="请选择市" clearable filterable style="width: 100%"
            :disabled="!form.province">
            <el-option v-for="item in cityOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="首字母" :label-width="formLabelWidth">
          <el-input placeholder="请输入首字母" v-model="form.firstletter" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="开放注册" label-width="80px">
          <el-row>
            <el-col :span="2">
              <el-radio class="radio" v-model="form.radio" label="1">是</el-radio>
            </el-col>
            <el-col :span="1">
              <el-radio class="radio" v-model="form.radio" label="2">否</el-radio>
            </el-col>
          </el-row>
        </el-form-item>
        <!-- <el-form-item label="是否自由切换校区" label-width="140px">
          <el-switch v-model="form.editChangeCampusZone" on-text="" off-text="" :disabled="isDisabled">
          </el-switch>
        </el-form-item> -->
        <el-form-item label="校区切换权限" label-width="140px">
          <el-row>
            <el-col :span="12">
              <span style="margin-right: 8px;">允许切入</span>
              <el-switch v-model="form.openChangeCampusZone" :disabled="isDisabled" on-text="" off-text="" ></el-switch>
            </el-col>
            <el-col :span="12">
              <span style="margin-right: 8px;">允许切出</span>
              <el-switch v-model="form.editChangeCampusZone" :disabled="isDisabled"  on-text="" off-text=""></el-switch>
            </el-col>
          </el-row>
        </el-form-item>
        <el-form-item label="校区类型" label-width="80px">
          <el-row>
            <el-col :span="2" v-show="form.schoolType == 1">
              <el-radio v-model="form.campusType" label="1" @input="changeCampusType">专科</el-radio>
            </el-col>
            <el-col :span="2" v-show="form.schoolType == 1">
              <el-radio v-model="form.campusType" label="2" @input="changeCampusType">本科</el-radio>
            </el-col>
            <el-col :span="2" v-show="form.schoolType == 4">
              <el-radio v-model="form.campusType" label="3" @input="changeCampusType">高中</el-radio>
            </el-col>
          </el-row>
        </el-form-item>
        <el-form-item label="是否开启体测总分" label-width="140px" v-show="form.schoolType == 1">
          <el-switch v-model="form.openTotalScore" on-text="" off-text="" :disabled="isDisabled"></el-switch>
        </el-form-item>
        <el-form-item label="体测总分:" :label-width="formLabelWidth" v-show="form.openTotalScore">
          <el-row>
            <el-col :span="1">
              <div align="center">大一</div>
            </el-col>
            <el-col :span="1">
              <el-input v-model="form.physicalConfig[0].molecule" auto-complete="off"></el-input>
            </el-col>
            <el-col :span="1">
              <div align="center">/</div>
            </el-col>
            <el-col :span="1">
              <el-input v-model="form.physicalConfig[0].denominator" auto-complete="off"></el-input>
            </el-col>
            <el-col :span="1" :offset="1">
              <div align="center">大二</div>
            </el-col>
            <el-col :span="1">
              <el-input v-model="form.physicalConfig[1].molecule" auto-complete="off"></el-input>
            </el-col>
            <el-col :span="1">
              <div align="center">/</div>
            </el-col>
            <el-col :span="1">
              <el-input v-model="form.physicalConfig[1].denominator" auto-complete="off"></el-input>
            </el-col>
            <el-col :span="1" :offset="1">
              <div align="center">大三</div>
            </el-col>
            <el-col :span="1">
              <el-input v-model="form.physicalConfig[2].molecule" auto-complete="off"></el-input>
            </el-col>
            <el-col :span="1">
              <div align="center">/</div>
            </el-col>
            <el-col :span="1">
              <el-input v-model="form.physicalConfig[2].denominator" auto-complete="off"></el-input>
            </el-col>
            <el-col :span="1" :offset="1" v-show="form.campusType === '2'">
              <div align="center">大四</div>
            </el-col>
            <el-col :span="1" v-show="form.campusType === '2'">
              <el-input v-model="form.physicalConfig[3].molecule" auto-complete="off"></el-input>
            </el-col>
            <el-col :span="1" v-show="form.campusType === '2'">
              <div align="center">/</div>
            </el-col>
            <el-col :span="1" v-show="form.campusType === '2'">
              <el-input v-model="form.physicalConfig[3].denominator" auto-complete="off"></el-input>
            </el-col>
          </el-row>
        </el-form-item>

        <el-form-item label="学校任务跑用户" :label-width="formLabelWidth" required>
          <el-checkbox-group v-model="form.schoolTaskRunGrades">
            <el-checkbox :label="1">大一</el-checkbox>
            <el-checkbox :label="2">大二</el-checkbox>
            <el-checkbox :label="3">大三</el-checkbox>
            <el-checkbox :label="4">大四</el-checkbox>
            <el-checkbox :label="5">其他</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item label='运动世界APP固定展示“自由跑”' :label-width="formLabelWidth">
          <el-switch v-model="form.showFreeRunEnableSwitch" on-text="" off-text=""></el-switch>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="addcampus">确 定</el-button>
      </div>
    </el-dialog>

    <el-select style="width: 500px; margin-left: 20px" v-model="value" filterable clearable placeholder="请输入高校或校区名称"
      @change="neirong">
      <el-option v-for="item in options" :value="item.unid" :key="item.unid" :label="item.name">
      </el-option>
    </el-select>

    <div style="height: 15px; clear: both; overflow: hidden; width: 100%"></div>

    <div class="com-list">
      <el-table :data="tableData" border style="width: 100%">
        <el-table-column type="index" label="序号" width="80" align="center"></el-table-column>
        <el-table-column prop="zoneName" label="校区名称" width="280" align="center"></el-table-column>
        <el-table-column label="省份" width="120" align="center">
          <template scope="{ row }">{{ getProvinceName(row.province) }}</template>
        </el-table-column>
        <el-table-column label="市" width="120" align="center">
          <template scope="{ row }">{{ getCityName(row.province, row.city) }}</template>
        </el-table-column>
        <el-table-column prop="pointsNum" label="点位数量" align="center"> </el-table-column>
        <el-table-column prop="campusType" label="学校类型" align="center"></el-table-column>
        <el-table-column label="学校任务跑用户" min-width="220" align="center">
          <template scope="{ row }">{{ formatSchoolTaskRunGrades(row) }}</template>
        </el-table-column>
        <el-table-column label='自由跑固定展示' width="140" align="center">
          <template scope="{ row }">{{ row && row.showFreeRunEnableSwitch ? "开启" : "关闭" }}</template>
        </el-table-column>
        <el-table-column prop="openRegistration" label="是否开放注册" align="center"></el-table-column>
        <el-table-column prop="openTotalScore" label="是否开启体测总分" align="center"></el-table-column>
        <el-table-column label="是否开放场馆系统" width="180" align="center"></el-table-column>
        <el-table-column inline-template label="校区切换权限" align="center">
          <span>
            {{ row.openChangeCampusZone ? "允许切入 " : "" }}{{ row.editChangeCampusZone ? "允许切出" : "" }}
            {{ !row.openChangeCampusZone && !row.editChangeCampusZone ? "不允许切换" : "" }}
          </span>
        </el-table-column>
        <!-- <el-table-column inline-template label="是否自由切换校区" align="center">
          <span>
            {{ row.editChangeCampusZone ? "是" : "否" }}
          </span>
        </el-table-column> -->
        <el-table-column inline-template label="操作" width="200" align="center">
          <span>
            <el-button type="text" size="small" @click="editschool(row)">编辑</el-button>
            <el-button type="text" size="small" @click="deleteSchool($index, row)">删除</el-button>
          </span>
        </el-table-column>
      </el-table>
    </div>

    <el-pagination layout="prev, pager, next" :page-size="20" :page-count="pageCount">
    </el-pagination>

    <el-dialog title="编辑校区" v-model="dialogFormVisibleedit" :modal-append-to-body="false">
      <el-form :model="formedit" label-position="left">
        <el-form-item label="注意事项" :label-width="formLabelWidth">
          <br />
          <p>1,若修改的是学校名称，请确保对该校校区逐一进行此操作</p>
          <p>2,开放注册的调整对该校所有校区生效</p>
          <p>3,新增时，若学校名和首字母为空，则不能新增。新增时默认关闭开放注册</p>
          <p>4,新增时，若为新增某校下的校区，这时的是否开放注册会影响其他校区。</p>
        </el-form-item>
        <el-form-item label="高校名称" :label-width="formLabelWidth">
          <el-input v-model="formedit.schoolname" placeholder="请输入高校名称" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="校区名称" :label-width="formLabelWidth">
          <el-input v-model="formedit.campusname" placeholder="请输入校区名称" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="省份" :label-width="formLabelWidth" required>
          <el-select v-model="formedit.province" placeholder="请选择省份" clearable filterable style="width: 100%"
            @change="formedit.city = ''">
            <el-option v-for="item in provinceList" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="市" :label-width="formLabelWidth" required>
          <el-select v-model="formedit.city" placeholder="请选择市" clearable filterable style="width: 100%"
            :disabled="!formedit.province">
            <el-option v-for="item in cityOptionsEdit" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="首字母" :label-width="formLabelWidth">
          <el-input v-model="formedit.firstletter" placeholder="请输入首字母" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="开放注册" label-width="80px">
          <el-row>
            <el-col :span="2">
              <el-radio class="radio" v-model="formedit.radio" label="1">是</el-radio>
            </el-col>
            <el-col :span="1">
              <el-radio class="radio" v-model="formedit.radio" label="2">否</el-radio>
            </el-col>
          </el-row>
        </el-form-item>
        <!-- <el-form-item label="是否自由切换校区" label-width="140px">
          <el-switch v-model="formedit.editChangeCampusZone" on-text="" off-text="" :disabled="isDisabled">
          </el-switch>
        </el-form-item> -->
        <el-form-item label="校区切换权限" label-width="140px">
          <el-row>
            <el-col :span="12">
              <span style="margin-right: 8px;">允许切入</span>
              <el-switch v-model="formedit.openChangeCampusZone" :disabled="isDisabled" on-text="" off-text=""></el-switch>
            </el-col>
            <el-col :span="12">
              <span style="margin-right: 8px;">允许切出</span>
              <el-switch v-model="formedit.editChangeCampusZone" :disabled="isDisabled" on-text="" off-text=""></el-switch>
            </el-col>
          </el-row>
        </el-form-item>
        <el-form-item label="校区类型" label-width="80px">
          <el-row>
            <el-col :span="2" v-show="formedit.schoolType == 1">
              <el-radio v-model="formedit.campusType" label="1" @input="changeCampusType">专科</el-radio>
            </el-col>
            <el-col :span="1" v-show="formedit.schoolType == 1">
              <el-radio v-model="formedit.campusType" label="2" @input="changeCampusType">本科</el-radio>
            </el-col>
            <el-col :span="2" v-show="formedit.schoolType == 4">
              <el-radio v-model="formedit.campusType" label="3" @input="changeCampusType">高中</el-radio>
            </el-col>
          </el-row>
        </el-form-item>
        <el-form-item label="是否开启体测总分" label-width="140px" v-show="formedit.schoolType == 1">
          <el-switch v-model="formedit.openTotalScore" on-text="" off-text="" :disabled="isDisabled"></el-switch>
        </el-form-item>
        <el-form-item label="体测总分:" :label-width="formLabelWidth" v-show="formedit.openTotalScore">
          <el-row>
            <el-col :span="1">
              <div align="center">大一</div>
            </el-col>
            <el-col :span="1">
              <el-input v-model="formedit.physicalConfig[0].molecule" auto-complete="off"></el-input>
            </el-col>
            <el-col :span="1">
              <div align="center">/</div>
            </el-col>
            <el-col :span="1">
              <el-input v-model="formedit.physicalConfig[0].denominator" auto-complete="off"></el-input>
            </el-col>
            <el-col :span="1" :offset="1">
              <div align="center">大二</div>
            </el-col>
            <el-col :span="1">
              <el-input v-model="formedit.physicalConfig[1].molecule" auto-complete="off"></el-input>
            </el-col>
            <el-col :span="1">
              <div align="center">/</div>
            </el-col>
            <el-col :span="1">
              <el-input v-model="formedit.physicalConfig[1].denominator" auto-complete="off"></el-input>
            </el-col>
            <el-col :span="1" :offset="1">
              <div align="center">大三</div>
            </el-col>
            <el-col :span="1">
              <el-input v-model="formedit.physicalConfig[2].molecule" auto-complete="off"></el-input>
            </el-col>
            <el-col :span="1">
              <div align="center">/</div>
            </el-col>
            <el-col :span="1">
              <el-input v-model="formedit.physicalConfig[2].denominator" auto-complete="off"></el-input>
            </el-col>
            <el-col :span="1" :offset="1" v-show="formedit.campusType === '2'">
              <div align="center">大四</div>
            </el-col>
            <el-col :span="1" v-show="formedit.campusType === '2'">
              <el-input v-model="formedit.physicalConfig[3].molecule" auto-complete="off"></el-input>
            </el-col>
            <el-col :span="1" v-show="formedit.campusType === '2'">
              <div align="center">/</div>
            </el-col>
            <el-col :span="1" v-show="formedit.campusType === '2'">
              <el-input v-model="formedit.physicalConfig[3].denominator" auto-complete="off"></el-input>
            </el-col>
          </el-row>
        </el-form-item>

        <el-form-item label="学校任务跑用户" :label-width="formLabelWidth" required>
          <el-checkbox-group v-model="formedit.schoolTaskRunGrades">
            <el-checkbox :label="1">大一</el-checkbox>
            <el-checkbox :label="2">大二</el-checkbox>
            <el-checkbox :label="3">大三</el-checkbox>
            <el-checkbox :label="4">大四</el-checkbox>
            <el-checkbox :label="5">其他</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item label='运动世界APP固定展示“自由跑”' :label-width="formLabelWidth">
          <el-switch v-model="formedit.showFreeRunEnableSwitch" on-text="" off-text=""></el-switch>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisibleedit = false">取 消</el-button>
        <el-button type="primary" @click="editschoolsubmit">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { provinceListConst } from "../../../common/constant.js";
import { cityListByProvinceCode } from "../../../common/cityByProvince.js";

export default {
  data() {
    return {
      pageCount: 1,
      tableData: [],
      input2: "",
      options: [],
      dialogFormVisible: false,
      provinceList: provinceListConst,
      form: {
        schoolType: 1,
        name: "",
        namecampus: "",
        province: "",
        city: "",
        radio: "2",
        firstletter: "",
        // 学校任务跑用户年级：1-大一，2-大二，3-大三，4-大四，5-其他（默认勾选大一~大四）
        schoolTaskRunGrades: [1, 2, 3, 4],
        // 是否展示自由跑开启开关（默认关闭）
        showFreeRunEnableSwitch: false,
        openChangeCampusZone: false,
        editChangeCampusZone: false,
        campusType: "2",
        openTotalScore: false,
        physicalConfig: [
          { molecule: 1, denominator: 6 },
          { molecule: 1, denominator: 6 },
          { molecule: 1, denominator: 6 },
          { molecule: 1, denominator: 2 },
        ]
      },
      formedit: {
        schoolname: "",
        schoolType: 1,
        campusname: "",
        province: "",
        city: "",
        radio: "",
        firstletter: "",
        unid: "",
        rootUnid: "",
        // 学校任务跑用户年级：1-大一，2-大二，3-大三，4-大四，5-其他（已有校区默认勾选大一~大四）
        schoolTaskRunGrades: [1, 2, 3, 4],
        // 是否展示自由跑开启开关（默认关闭）
        showFreeRunEnableSwitch: false,
        openChangeCampusZone: false,
        editChangeCampusZone: false,
        campusType: "",
        openTotalScore: false,
        physicalConfig: [
          { molecule: 1, denominator: 1 },
          { molecule: 0, denominator: 1 },
          { molecule: 0, denominator: 1 },
          { molecule: 0, denominator: 1 },
        ]
      },
      options1: [],
      value2: {},
      value: "",
      inputnewschoolvisble: false,
      inputnewschool: "",
      inputnewschoolactual: "",
      dialogFormVisibleedit: false,
      beforeschoolname: "",
      beforecampusname: "",
      beforeradio: "",
      beforefirstLetter: "", //最初的首字母
      isEditCampusName: "", //是否修改了校区名
      isOpenRegistration: "", //是否开放注册
      isEditOpenRegistration: "", //是否编辑了开放注册属性
      rowstate: "", //记住之前的row
    };
  },
  computed: {
    cityOptions() {
      return (cityListByProvinceCode[this.form.province] || []);
    },
    cityOptionsEdit() {
      return (cityListByProvinceCode[this.formedit.province] || []);
    }
  },
  mounted() {
    this.getschoolandunid();
  },
  methods: {
    getProvinceName(code) {
      if (!code) return "";
      const item = provinceListConst.find((p) => p.value === code);
      return item ? item.label : code;
    },
    getCityName(provinceCode, cityCode) {
      if (!cityCode) return "";
      const list = cityListByProvinceCode[provinceCode];
      if (!list) return cityCode;
      const item = list.find((c) => c.value === cityCode);
      return item ? item.label : cityCode;
    },
    formatSchoolTaskRunGrades(row) {
      const map = { 1: "大一", 2: "大二", 3: "大三", 4: "大四", 5: "其他" };
      const raw = row && Array.isArray(row.schoolTaskRunGrades) ? row.schoolTaskRunGrades : [];
      const list = raw
        .map((x) => Number(x))
        .filter((n) => Number.isFinite(n) && n >= 1 && n <= 5);
      if (!list.length) return "—";
      const uniq = [...new Set(list)].sort((a, b) => a - b);
      return uniq.map((n) => map[n]).filter(Boolean).join("、") || "—";
    },
    getschoolandunid() {
      this.$http({
        method: "GET",
        url: this.$util.domain + "/adminapi/v1/basicTools/allCampusZones",
      }).then((response) => {
        if (response.data.error == 10000) {
          this.options = response.body.data; //给option数组赋值，这里要在下拉列表里面展示出来
        } else {
          this.$util.errorMsg(response.data.message);
        }
      });
    },
    neirong() {
      if (!this.value) {
        this.tableData = [];
        return;
      }
      //获取所有校区信息
      this.$http({
        method: "GET",
        url: this.$util.domain + "/adminapi/v1/campus/campuszone/queryZoneInfo",
        params: {
          unid: this.value,
        },
      }).then((response) => {
        if (response.data.error == 10000) {
          this.tableData = response.body.data;
          if (this.tableData.length) {
            for (let i = 0; i < this.tableData.length; i++) {
              this.tableData[i].openRegistration = this.tableData[i].openRegistration ? "是" : "否";
              if (this.tableData[i].campusCustomConfig) {
                if (this.tableData[i].campusCustomConfig.campusType == 1) {
                  this.tableData[i].campusType = "专科";
                } else if (this.tableData[i].campusCustomConfig.campusType == 2) {
                  this.tableData[i].campusType = "本科";
                } else if (this.tableData[i].campusCustomConfig.campusType == 3) {
                  this.tableData[i].campusType = "高中";
                }
                this.tableData[i].openTotalScore = this.tableData[i].campusCustomConfig.openTotalScore ? "是" : "否";
              } else {
                this.tableData[i].campusType = "";
                this.tableData[i].openTotalScore = "";
              }
            }
          }
        } else {
          this.$util.errorMsg(response.data.message);
        }
      });
    },
    // 点击编辑按钮
    editschool(row) {
      //编辑校区
      this.dialogFormVisibleedit = true; //显示弹框
      //给是否注册赋值
      this.formedit.radio = row.openRegistration == "是" ? "1" : "2";
      this.formedit.schoolname = row.zoneName.split(" ")[0]; //校区名称
      if (row.zoneName.split(" ").length == 1) {
        this.formedit.campusname = ""; //校区名称
      } else {
        this.formedit.campusname = row.zoneName.split(" ")[1]; //校区名称
      }
      this.formedit.schoolType = row.schoolType || 1;
      this.formedit.unid = row.unid;
      this.formedit.firstletter = row.firstLetter;
      this.formedit.province = row.province || "";
      this.formedit.city = row.city || "";
      this.beforeschoolname = this.formedit.schoolname;
      this.beforecampusname = this.formedit.campusname;
      this.beforeradio = this.formedit.radio;
      this.rowstate = row;
      this.formedit.openChangeCampusZone = row.openChangeCampusZone;
      this.formedit.editChangeCampusZone = row.editChangeCampusZone;
      this.formedit.campusType = row.campusCustomConfig ? row.campusCustomConfig.campusType + "" : "";
      this.formedit.openTotalScore = row.campusCustomConfig ? row.campusCustomConfig.openTotalScore : false;
      // 学校任务跑用户（多选必选）：已有校区默认大一~大四
      if (row && Array.isArray(row.schoolTaskRunGrades) && row.schoolTaskRunGrades.length) {
        this.formedit.schoolTaskRunGrades = row.schoolTaskRunGrades
          .map((x) => Number(x))
          .filter((n) => Number.isFinite(n) && n >= 1 && n <= 5);
      } else {
        this.formedit.schoolTaskRunGrades = [1, 2, 3, 4];
      }
      this.formedit.showFreeRunEnableSwitch = !!row.showFreeRunEnableSwitch;
      if (row.campusCustomConfig.physicalConfig) {
        this.resetPhysicalConfig(0);
        row.campusCustomConfig.physicalConfig.forEach(item => {
          if (item.grade >= 1 && item.grade <= this.formedit.physicalConfig.length) {
            this.formedit.physicalConfig[item.grade - 1].molecule = item.molecule;
            this.formedit.physicalConfig[item.grade - 1].denominator = item.denominator;
          }
        });
      } else {
        if (this.formedit.campusType === "1") {
          this.resetPhysicalConfig(1);
        } else if (this.formedit.campusType === "2") {
          this.resetPhysicalConfig(2);
        } else {
          this.resetPhysicalConfig(0);
        }
      }
    },
    // 重置体测总分配置
    resetPhysicalConfig(type) {
      if (type == 1) {
        this.form.physicalConfig = [
          { molecule: 1, denominator: 4 },
          { molecule: 1, denominator: 4 },
          { molecule: 1, denominator: 2 },
          { molecule: 0, denominator: 1 },
        ];
        this.formedit.physicalConfig = [
          { molecule: 1, denominator: 4 },
          { molecule: 1, denominator: 4 },
          { molecule: 1, denominator: 2 },
          { molecule: 0, denominator: 1 },
        ];
      } else if (type == 2) {
        this.form.physicalConfig = [
          { molecule: 1, denominator: 6 },
          { molecule: 1, denominator: 6 },
          { molecule: 1, denominator: 6 },
          { molecule: 1, denominator: 2 },
        ];
        this.formedit.physicalConfig = [
          { molecule: 1, denominator: 6 },
          { molecule: 1, denominator: 6 },
          { molecule: 1, denominator: 6 },
          { molecule: 1, denominator: 2 },
        ];
      } else {
        this.form.physicalConfig = [
          { molecule: 1, denominator: 1 },
          { molecule: 0, denominator: 1 },
          { molecule: 0, denominator: 1 },
          { molecule: 0, denominator: 1 },
        ];
        this.formedit.physicalConfig = [
          { molecule: 1, denominator: 1 },
          { molecule: 0, denominator: 1 },
          { molecule: 0, denominator: 1 },
          { molecule: 0, denominator: 1 },
        ];
      }
    },
    // 切换学校类型
    changeSchoolType(value) {
      if (value == 1) {
        this.form.campusType = '2'
        this.resetPhysicalConfig(2);
      } else if (value == 4) {
        this.form.campusType = '3'
        this.resetPhysicalConfig(0);
      }
      this.form.openTotalScore = false;
    },
    // 切换校区类型
    changeCampusType(value) {
      if (value === "1") {
        this.resetPhysicalConfig(1);
      } else if (value === "2") {
        this.resetPhysicalConfig(2);
      }
    },
    // 编辑校区提交
    editschoolsubmit() {
      if (
        this.beforeschoolname + this.beforecampusname ===
        this.trim(this.formedit.schoolname) +
        this.trim(this.formedit.campusname)
      ) {
        this.isEditCampusName = false;
      } else {
        this.isEditCampusName = true;
      }
      // 省份或城市有变更时也视为修改了校区信息
      if (
        this.formedit.province !== (this.rowstate.province || "") ||
        this.formedit.city !== (this.rowstate.city || "")
      ) {
        this.isEditCampusName = true;
      }
      //是否开放注册，后台返回的是true和false，我本地目前的标识是1和2
      if (this.beforeradio == this.formedit.radio) {
        this.isEditOpenRegistration = false;
      } else {
        this.isEditOpenRegistration = true;
      }
      if (this.formedit.radio == "1") {
        this.isOpenRegistration = true;
      } else if (this.formedit.radio == "2") {
        this.isOpenRegistration = false;
      }
      if (this.trim(this.formedit.schoolname) == "") {
        this.$util.errorMsg("请先输入高校名称");
        return false;
      }
      if (!this.formedit.province) {
        this.$util.errorMsg("请选择省份");
        return false;
      }
      if (!this.formedit.city) {
        this.$util.errorMsg("请选择市");
        return false;
      }
      if (this.trim(this.formedit.firstletter) == "") {
        this.$util.errorMsg("请输入首字母");
        return false;
      }
      const reg = /^[A-Za-z]+$/;
      if (!reg.test(this.formedit.firstletter)) {
        this.$util.errorMsg("首字母格式不正确");
        return false;
      }
      if (this.formedit.firstletter.length > 1) {
        this.$util.errorMsg("首字母字符太长");
        return false;
      }
      if (this.formedit.campusType === "") {
        this.$util.errorMsg("请选择校区类型");
        return false;
      }
      if (!this.formedit.schoolTaskRunGrades || !this.formedit.schoolTaskRunGrades.length) {
        this.$util.errorMsg("请至少选择一个学校任务跑用户年级");
        return false;
      }
      if (this.formedit.openTotalScore) {
        let hasZero = false
        this.formedit.physicalConfig.forEach((item, index) => {
          if (item.denominator == 0) {
            hasZero = true
          }
        })
        if (hasZero) {
          this.$util.errorMsg("体测总分中的分母部分不能为0");
          return false;
        }
        let molecule = 0;
        let denominator = 1;
        this.formedit.physicalConfig.forEach((item, index) => {
          denominator *= item.denominator;
        })
        this.formedit.physicalConfig.forEach((item, index) => {
          molecule += item.molecule * denominator / item.denominator;
        })
        if (molecule != denominator) {
          this.$util.errorMsg("体测总分中的分数总和不等于1");
          return false;
        }
      }
      let bodyData = {
        unid: this.formedit.unid,
        schoolName: this.trim(this.formedit.schoolname), //学校名称
        zoneName: this.trim(this.formedit.campusname), //校区名
        province: this.formedit.province || "",
        city: this.formedit.city || "",
        isEditCampusName: this.isEditCampusName, //是否修改了校区名
        isOpenRegistration: this.isOpenRegistration, //是否开放注册
        isEditOpenRegistration: this.isEditOpenRegistration, //是否编辑了开放注册属性
        firstLetter: this.formedit.firstletter.toLocaleUpperCase(), //首字母,转成大写
        schoolTaskRunGrades: (this.formedit.schoolTaskRunGrades || [])
          .map((x) => Number(x))
          .filter((n) => Number.isFinite(n) && n >= 1 && n <= 5),
        showFreeRunEnableSwitch: !!this.formedit.showFreeRunEnableSwitch,
        openChangeCampusZone: this.formedit.openChangeCampusZone,
        editChangeCampusZone: this.formedit.editChangeCampusZone,
        campusConfig: {
          campusType: this.formedit.campusType,
          openTotalScore: this.formedit.openTotalScore
        }
      };
      if (this.formedit.openTotalScore) {
        bodyData.campusConfig["physicalConfig"] = this.formedit.physicalConfig.filter((item, index) => {
          let grade = this.formedit.campusType === "1" ? 3 : 4
          return index < grade;
        }).map((item, index) => {
          return {
            grade: `${index + 1}`,
            molecule: item.molecule,
            denominator: item.denominator
          }
        })
      }
      this.$http({
        method: "post",
        url: this.$util.domain + "/adminapi/v1/campus/campuszone/editZone",
        body: JSON.stringify(bodyData),
      }).then((response) => {
        if (response.data.error == 10000) {
          this.$util.successMsg("编辑成功");
          this.rowstate.zoneName =
            this.formedit.schoolname + " " + this.formedit.campusname; //高校名字
          this.rowstate.firstLetter = this.formedit.firstletter; //首字母
          if (this.formedit.radio == "1") {
            this.rowstate.openRegistration = "是";
          } else {
            this.rowstate.openRegistration = "否";
          }
          this.dialogFormVisibleedit = false; //请求成功后关掉弹出框
          this.neirong()
        } else {
          this.$util.errorMsg(response.data.message);
        }
      });
    },
    deleteSchool(index, row) {
      this.$http({
        method: "post",
        credentials: true,
        url:
          this.$util.domain +
          "/adminapi/v1/campus/campuszone/deleteZone?unid=" +
          row.unid,
      }).then((response) => {
        //各种错误码,-1该校区存在用户，无法删除
        if (response.data.error == 10000) {
          this.$util.successMsg("删除成功");
          this.tableData.splice(index, index + 1); //这样就能实时更新了
        } else {
          this.$util.errorMsg(response.data.message);
        }
      });
    },
    trim(string) {
      return string.replace(/(^\s*)|(\s*$)/g, "");
    },
    // 新增校区并获取所有学校
    getallschool() {
      this.dialogFormVisible = true;
      this.form.schoolTaskRunGrades = [1, 2, 3, 4];
      this.form.showFreeRunEnableSwitch = false;
      this.$http({
        method: "get",
        url: this.$util.domain + "/adminapi/v1/basicTools/allSchools",
      }).then((response) => {
        if (response.data.error == 10000) {
          this.options1 = response.data.data;
          if (this.options1.length > 0) {
            let item = this.options1[this.options1.length - 1]
            this.value2 = item.rootUnid + ',' + item.firstLetter + ',' + item.name
          }
        } else {
          this.$util.errorMsg(response.data.message);
        }
      });
    },
    // 查询学校类型
    querySchoolType(unid) {
      if (!unid) { return; }
      this.$http({
        url: this.$util.domain + '/adminapi/v1/campus/campuszone/getSchoolType',
        method: 'GET',
        params: { unid: unid }
      }).then((res) => {
        if (res.data && res.data.error == 10000) {
          if (res.data.data == 4) {
            this.form.schoolType = 4;
            this.changeSchoolType(4);
          } else {
            this.form.schoolType = 1;
            this.changeSchoolType(1);
          }
        }
      });
    },
    isaddnewschool() {
      if (this.value2.split(",")[0] == "0") {
        this.inputnewschoolvisble = true;
        this.form.firstletter = "";
      } else {
        this.inputnewschoolvisble = false; //显示隐藏高校名称输入框
        this.form.firstletter = this.value2.split(",")[1];
        const rootUnid = this.value2.split(',')[0];
        this.querySchoolType(rootUnid);
      }
    },
    // 新增校区提交
    addcampus() {
      //如果unid等于0，并且没有输入高校名称
      if (
        this.value2.split(",")[0] == "0" &&
        this.trim(this.inputnewschool) == ""
      ) {
        this.$util.errorMsg("请先输入高校名称");
        return false;
      }

      if (
        this.value2.split(",")[0] != "0" &&
        this.trim(this.form.namecampus) == ""
      ) {
        this.$util.errorMsg("请先输入校区名称");
        return false;
      }

      if (this.trim(this.form.firstletter) == "") {
        this.$util.errorMsg("请输入首字母");
        return false;
      }
      if (this.form.campusType === "") {
        this.$util.errorMsg("请选择校区类型");
        return false;
      }
      if (!this.form.province) {
        this.$util.errorMsg("请选择省份");
        return false;
      }
      if (!this.form.city) {
        this.$util.errorMsg("请选择市");
        return false;
      }
      if (!this.form.schoolTaskRunGrades || !this.form.schoolTaskRunGrades.length) {
        this.$util.errorMsg("请至少选择一个学校任务跑用户年级");
        return false;
      }
      if (this.form.openTotalScore) {
        let hasZero = false
        this.form.physicalConfig.forEach((item, index) => {
          if (item.denominator == 0) {
            hasZero = true
          }
        })
        if (hasZero) {
          this.$util.errorMsg("体测总分中的分母部分不能为0");
          return false;
        }
        let molecule = 0;
        let denominator = 1;
        this.form.physicalConfig.forEach((item, index) => {
          denominator *= item.denominator;
        })
        this.form.physicalConfig.forEach((item, index) => {
          molecule += item.molecule * denominator / item.denominator;
        })
        if (molecule != denominator) {
          this.$util.errorMsg("体测总分中的分数总和不等于1");
          return false;
        }
      }
      if (this.form.radio == 1) {
        this.form.radio = true;
      } else if (this.form.radio == 2) {
        this.form.radio = false;
      }
      if (this.value2.split(",")[0] == "0") {
        //如果选择了其它，那么真实的名字应该是inputnewsschool里面填写的东西
        this.inputnewschoolactual = this.inputnewschool;
      } else {
        this.inputnewschoolactual = this.value2.split(",")[2];
      }
      let bodyData = {
        schoolName: this.inputnewschoolactual, //学校名
        schoolType: this.form.schoolType, // 学校类型 默认1大学，4高中
        zoneName: this.trim(this.form.namecampus), //校区名，可以是空
        province: this.form.province || "",
        city: this.form.city || "",
        isOpenRegistration: this.form.radio, //该校是否开放注册
        firstLetter: this.form.firstletter.toLocaleUpperCase(), //首字母
        rootUnid: this.value2.split(",")[0], //校区id，新增时，输入学校名称时，若有匹配，则传上来,没有匹配的传0
        schoolTaskRunGrades: (this.form.schoolTaskRunGrades || [])
          .map((x) => Number(x))
          .filter((n) => Number.isFinite(n) && n >= 1 && n <= 5),
        showFreeRunEnableSwitch: !!this.form.showFreeRunEnableSwitch,
        openChangeCampusZone: this.form.openChangeCampusZone,
        editChangeCampusZone: this.form.editChangeCampusZone,
        campusConfig: {
          campusType: this.form.campusType,
          openTotalScore: this.form.openTotalScore
        }
      }
      if (this.form.openTotalScore) {
        bodyData.campusConfig["physicalConfig"] = this.form.physicalConfig.filter((item, index) => {
          let grade = this.form.campusType === "1" ? 3 : 4
          return index < grade;
        }).map((item, index) => {
          return {
            grade: `${index + 1}`,
            molecule: item.molecule,
            denominator: item.denominator
          }
        })
      }
      this.$http({
        method: "post",
        url: this.$util.domain + "/adminapi/v1/campus/campuszone/editZone",
        body: JSON.stringify(bodyData),
      }).then((response) => {
        if (response.data.error == 10000) {
          this.$util.successMsg("添加成功");
          this.dialogFormVisible = false;
          this.neirong();
        } else {
          this.$util.errorMsg(response.data.message);
        }
      });
    },
  },
};
</script>

<style scoped>
.el-form-item {
  margin-bottom: 0;
}

.el-radio-group {
  margin-top: 8px;
  display: flex;
}
</style>



// WEBPACK FOOTER //
// schoolManage.vue?45bad2aa